var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChecklist = function SvgChecklist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1B216B",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.25 19.5a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5m0 1a4.25 4.25 0 1 0 0-8.5 4.25 4.25 0 0 0 0 8.5M5.625 13.342a.4.4 0 0 0 .313.158c.111 0 .22-.05.307-.15l.75-.884.573.664.857-.517.535.526h3.103c.242 0 .437-.236.437-.525s-.195-.525-.437-.525h-2.79l-.733-.72-.81.489L6.992 11l-1.36 1.6a.6.6 0 0 0-.007.742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 5.5h-.5v10h11.059q.084-.522.274-1H3.5v-8H20v5.333q.537.213 1 .544V5.5H3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 9.5h-.5v1H19v-1H5M4.5 7.5H19v1H4.5zM17.577 16.845l2.384-2.384.707.707-3.091 3.09-1.918-1.917.707-.707z"
  }))));
};
export { SvgChecklist as Icon };
export default __webpack_public_path__ + "static/media/4e3e2b8d29f3140406683f7233d19e4f.svg";